import {createSlice} from "@reduxjs/toolkit";
import { RootState } from "../store";

const initialState = {}

export const gameViewSlice = createSlice({
  name: 'gameView',
  initialState,
  reducers: {

  },
  // extraReducers: (builder) => {}

});

export const gameView = (state: RootState) => state.gameViewSlice;
export default gameViewSlice.reducer
// export const {} = gameViewSlice.actions